import React, {useEffect, useState} from 'react';
import {Box, Typography, CircularProgress} from '@material-ui/core';
import dayjs from 'dayjs';
import {apiGetFdApplicationAuditLogs} from 'constants/Api';
import {IFdApplicationAuditLog} from 'constants/interfaces';

export default function RecentApplicationChangesWidget() {
  const [logs, setLogs] = useState<IFdApplicationAuditLog[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);

    apiGetFdApplicationAuditLogs(10)
      .then((res) => {
        if (alive) setLogs(res || []);
      })
      .catch((err) => {
        console.error('Failed to load application audit logs for widget', err);
        if (alive) setLogs([]);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });

    return () => {
      alive = false;
    };
  }, []);

  const getFarmerName = (log: IFdApplicationAuditLog) => {
    const app = log.application;
    if (!app) return `Application #${log.applicationId}`;
    if (app.farm?.name) return app.farm.name;
    if (app.company?.name) return app.company.name;
    if (app.applyingUser?.name)
      return `${app.applyingUser.name} ${app.applyingUser.surname}`;
    return `Application #${log.applicationId}`;
  };

  const formatValue = (val?: string) => {
    if (val == null) return 'none';
    if (val.length > 20) return val.substring(0, 20) + '...';
    return val;
  };

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Typography
        className="widget-heading"
        style={{fontSize: 12, fontWeight: 700, color: '#666', marginBottom: 16}}
      >
        RECENT APPLICATION CHANGES
      </Typography>

      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flex={1}
        >
          <CircularProgress size={24} />
        </Box>
      ) : logs.length === 0 ? (
        <Typography variant="body2" color="textSecondary">
          No recent changes found.
        </Typography>
      ) : (
        <Box flex={1} overflow="auto">
          {logs.map((log) => (
            <Box
              key={log.id}
              display="flex"
              flexDirection="column"
              mb={2}
              style={{borderBottom: '1px solid #eee', paddingBottom: 8}}
            >
              <Box display="flex" justifyContent="space-between" mb={0.5}>
                <Typography variant="body2" style={{fontWeight: 600}}>
                  {getFarmerName(log)}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  {dayjs(log.changedAt).format('MMM D, HH:mm')}
                </Typography>
              </Box>
              <Typography variant="caption" color="textSecondary">
                <strong>{log.field}</strong> changed from{' '}
                <em>{formatValue(log.fromValue)}</em> to{' '}
                <em>{formatValue(log.toValue)}</em>
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
